export abstract class CryptoError extends Error {
  public abstract readonly kind: string;
}

export class AlgorithmNotFoundError extends CryptoError {
  kind = 'AlgorithmNotFound';
}

export class EntropyLimitReached extends CryptoError {
  kind = 'EntropyLimitReached';
}

export class UnknownError extends CryptoError {
  kind = 'Unknown';
  constructor(message: string) {
    super(message);
  }
}

export class I2ospError extends CryptoError {
  kind = 'I2osp';
  constructor(message: string) {
    super(message);
  }
}

export class InvalidKeyTypeError extends CryptoError {
  kind = 'InvalidKeyType';
}

export class DecryptionError extends CryptoError {
  kind = 'Decryption';
}

export class InvalidKeyError extends CryptoError {
  kind = 'InvalidKey';
}

export class InvalidKeyFormatError extends CryptoError {
  kind = 'InvalidKeyFormat';
}

export class NoKeyFoundError extends CryptoError {
  kind = 'NoKeyFound';
}

export class IncorrectKeyInputError extends CryptoError {
  kind = 'IncorrectKeyInput';
}

export class InvalidKeyLengthError extends CryptoError {
  kind = 'InvalidKeyLength';
}

export class KeyMismatchError extends CryptoError {
  kind = 'KeyMismatch';
}

export class ProhibitedUseError extends CryptoError {
  kind = 'ProhibitedUse';
}
